module.exports = __webpack_public_path__ + "static/media/declined_payment.420c31f6.gif";